import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../../shared/theme';
import useTheme from '../theme';
import { recordStatisticsEvent } from '../../../../services/statistics-service';

const CoverImage = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 18px 20px 0 0;
  margin-bottom: 16px;
  border-radius: 0;
  background-size: cover;
`;

const ListenButton = styled.div`
  display: flex;
  align-items: center;
  height: min-content;
  background-color: transparent;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 150ms cubic-bezier(0.5, 1, 0.89, 1);

  > span.listen {
    visibility: hidden;
    width: 0px;
    opacity: 0;
    color: ${props => dt(props).theme.primaryColor};
    font-size: 14px;
    font-weight:  ${props => dt(props).theme.fontWeightHeavy};
    transition: width 150ms cubic-bezier(0.5, 1, 0.89, 1) 50ms, opacity 150ms cubic-bezier(0.5, 1, 0.89, 1);

    ${props => props.theme.isROIMedium && `
      display: none;
    `};
  }

  &:hover {
    ${props => !props.theme.isROIMedium && `
      background-color: rgba(25, 32, 45, 0.75);
      transition: background-color 150ms cubic-bezier(0.5, 1, 0.89, 1);
    `};

    > span.listen {
      visibility: visible;
      width: 48px;
      padding: 0 12px 0 8px;
      opacity: 1;
      transition: width 150ms cubic-bezier(0.5, 1, 0.89, 1), opacity 150ms cubic-bezier(0.5, 1, 0.89, 1) 100ms;
    }
  }
`;

export default function ImageWithListenButton({ wire, section, position }) {
  const hasPodcast = _.indexOf(wire.mediaTypes, 'Podcast') >= 0;
  const listenIcon = (
    <span className="icon-lw icon-lw-listen">
      <span className="path1" />
      <span className="path2" />
    </span>
  );

  const listenButtonClicked = () => {
    recordStatisticsEvent({
      event: 'listen_link_click',
      statisticable: 'wire',
      id: wire.id,
      clicked_url: `/wires/${wire.slug}`,
      page: window.location.pathname,
      custom_data: {
        section,
        page: 'series',
        position,
      },
    });
  };

  return (
    <CoverImage
      style={{ backgroundImage: `url("${wire.primaryImageUrl}")`, aspectRatio: '16/9' }}
      theme={useTheme()}
    >
      {!!hasPodcast && (
      <ListenButton onClick={listenButtonClicked}>
        {listenIcon}
        <span className="listen">Listen</span>
      </ListenButton>
      )}
    </CoverImage>
  );
}

ImageWithListenButton.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    mediaTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    primaryImageUrl: PropTypes.string,
  }).isRequired,
  section: PropTypes.string.isRequired,
  position: PropTypes.number,
};

ImageWithListenButton.defaultProps = {
  position: null,
};
